<template>
  <div id="logo" :class="[companyClass]">
    <span class="company-logo"></span>
    <span class="text">{{ pageName }}</span>
  </div>

  <div id="spin" :style="styleObject">
    <a-spin size="large" tip="数据加载中...">
      <div class="spin-content"></div>
    </a-spin>
  </div>

  <div id="container">
  </div>

  <switcher :panes="panes"
    :defaultPaneId="defaultPaneId"
    @switch-pane="onPaneChange"
  />

  <router-view></router-view>

</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

import "leaflet/dist/leaflet.css"
import Switcher from '../components/control/Switcher.vue'

import L from '../modules/leaflet'
import MapWrapper from '../modules/map'

const CHINA_BOUND_FIT = [[52, 134],[21, 74]]
//const RADAR_BOUND = [[12.7700338517, 63.8148899733],[56.3833398551, 143.536486117]]

export default {
  setup() {
    const store = useStore()

    const panes = computed(() => store.state.panes)
    const currentPaneId = computed(() => store.state.currentPaneId)
    const loading = computed(() => store.state.loading)
    const switchPane = (paneId) => store.dispatch('switchPane', { paneId })

    return {
      loading,
      currentPaneId,
      panes,
      switchPane
    }
  },

  components: {
    Switcher,
  },

  data() {
    return {
      zoom: 5,
      options: {
        zoomAnimation: true,
        zoomControl: true, 
        attributionControl: false
      }
    }
  },

  computed: {
    pageName() {
      let name = location.host
      if (name.indexOf("honda") > -1) {
        document.title = "本田天气地图"
        return "本田天气地图"
      }
      return "天气地图"
    }, 

    styleObject() {
      return this.loading ? {} : { "display": "none" }
    },

    companyClass() {
      let name = location.host
      if (name.indexOf("honda") > -1) {
        return "honda"
      }
      return "seniverse"
    },

    defaultPaneId() {
      return this.$route.name
    }
  },

  async beforeMount() {
    this.mapIsReady = true;
  },

  mounted() {
    this.initMap()
    this.$store.state.currentPaneId = this.$route.name
  },

  methods: {
    onPaneChange(paneId) {
      this.switchPane(paneId)
      this.$router.push(paneId)
    },

    initMap() {
      console.log("starting init map container .....")
      let opt = { maxZoom: 18, minZoom: 3 }

      let base = L.tileLayer.chinaProvider('GaoDe.Normal.Map', opt)
      var mapbox = L.tileLayer.chinaProvider('MapBox.Normal.Gray', opt)
      var mapboxAnnotion = L.tileLayer.chinaProvider('MapBox.Normal.Annotion', opt)
      var image = L.tileLayer.chinaProvider('GaoDe.Satellite.Map', opt)
      var imageAnnotion = L.tileLayer.chinaProvider('GaoDe.Satellite.Annotion', opt)

      var grayscale = L.layerGroup([mapbox, mapboxAnnotion])
      var satellite = L.layerGroup([image, imageAnnotion])

      var baseLayers = {
        'Streets': base,
        'Grayscale': grayscale,
        'Satellite': satellite
      }

      var map = L.map("container", {
        layers: [grayscale],
        zoomControl: false, 
        attributionControl: false
      })

      L.control.attribution({prefix: false}).addTo(map)
      L.control.zoom({
        position: 'topleft',
        zoomInTitle: '放大',
        zoomOutTitle: '缩小'
      }).addTo(map)
      L.control.layers(baseLayers, null, {position: 'topleft'}).addTo(map)
      grayscale.addTo(map)

      map.on('click', function(ev) {
        console.log(ev)
        console.log(ev.latlng)
      })

      map.fitBounds(CHINA_BOUND_FIT)
      //.setView([38.62, 114.7], 10)

      map.on('zoomend', function() {
        var zoom = this.getZoom()
        var container = this.getContainer()

        if (zoom >= 4 && zoom <= 6) {
          L.DomUtil.addClass(container, "alarm-small")
          L.DomUtil.removeClass(container, "alarm-big")
        }

        if (zoom > 6) {
          L.DomUtil.addClass(container, "alarm-big")
          L.DomUtil.removeClass(container, "alarm-small")
        }
      })

      this.$store.dispatch('setMap', { map: new MapWrapper(map) })
    }
  }
}
</script>

<style>

#spin {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.3); 
  position: absolute;
  z-index: 1000;
  cursor: wait;
}

#spin .ant-spin-nested-loading {
  height: 100%;
}

#spin .ant-spin {
  max-height: 100%
}

#spin .ant-spin-dot {
  font-size: 60px
}

#spin .ant-spin-dot-item {
  background-color: #fff;
  width:30px;
  height: 30px;
}

#spin .ant-spin-text {
  color: #fff;
  font-size: 20px;
  text-shadow: 0px;
  padding-top: 55px;
  padding-left: 20px;
}

#logo {
    z-index: 30; 
    background-color: rgba(255, 255, 255, 1); 
    border-radius: 30px; 
    margin-top:10px;
    padding: 10px 20px;
    position: relative;
    opacity: 0.8;
    position: absolute;
    top: 0;
    left: 50%!important;
    transform: translateX(-50%)!important;
}

#logo:hover {background-color: rgba(255, 255, 255, 1); }

#logo .company-logo {

}

#logo.seniverse .company-logo {
    background-image: url('https://static.sencdn.com/brand/logo/logo-red-2x.png');
    background-size: 25px;
    width: 25px;
    height: 25px;
    display: block;
    background-repeat: no-repeat;
    margin: -2px 5px -2px 0px;
    float: left;
}

#logo.seniverse {display: none}

#logo.honda .company-logo {
    background-image: url('https://www.honda.com/-/media/Honda-Homepage/Images/Logos/svg/Honda-Power-Of-Dreams-New.svg');
    background-size: 100px;
    width: 100px; height: 20px;
    display: block;
    background-position: 0px 5px;
    background-repeat: no-repeat;
    margin:-2px 8px 0px 0px;
    float:left;
}

#logo .text {float:left; display: block;}

#container {width:100%; height: 100%; z-index: 10;border:0px solid red;}

.leaflet-container .leaflet-control-attribution{
  background: rgba(255, 255, 255, 0.0)
}

.leaflet-control-layers-list div {
  text-align: left
}

#copyright-logo img{height: 40px;}

@media (max-width: 780px) {
    #logo .company-logo {background-size: 80px; width: 80px; height: 16px;}
}

</style>